import { useEffect, useRef } from "react";

const INTERVAL_MS = 60_000; // 1 минута — совпадает с прежним useTourPolling

// Пока среди видимых слотов есть прогон в статусе processing, периодически
// перезапрашиваем историю, чтобы слоты сами перешли в done/empty/failed.
export function useHistoryPolling(refetch: () => void, isProcessing: boolean) {
  const refetchRef = useRef(refetch);
  refetchRef.current = refetch;

  useEffect(() => {
    if (!isProcessing) return;

    const id = setInterval(() => refetchRef.current(), INTERVAL_MS);
    return () => clearInterval(id);
  }, [isProcessing]);
}
